module.exports = __webpack_public_path__ + "static/media/test1 (23).5853c104.jpg";